/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
import AbstractKafkaCodeSnippet from './AbstractKafkaCodeSnippet';
import { SASL_MECHANISMS, SECURITY_PROTOCOLS } from '../constants';

export default class RdKafkaCodeSnippet extends AbstractKafkaCodeSnippet {
  sasl_ssl() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: SASL_MECHANISMS.PLAIN,
      securityProtocol: SECURITY_PROTOCOLS.SASL_SSL
    };
  }

  sasl_plain() {
    return {
      SASL: true,
      saslMechanism: SASL_MECHANISMS.PLAIN,
      securityProtocol: SECURITY_PROTOCOLS.SASL_PLAINTEXT
    };
  }

  sasl_sha_256() {
    return {
      SASL: true,
      saslMechanism: SASL_MECHANISMS.SCRAM256,
      securityProtocol: SECURITY_PROTOCOLS.SASL_PLAINTEXT
    };
  }

  sasl_sha_512() {
    return {
      SASL: true,
      saslMechanism: SASL_MECHANISMS.SCRAM512,
      securityProtocol: SECURITY_PROTOCOLS.SASL_PLAINTEXT
    };
  }

  sasl_ssl_sha_256() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: SASL_MECHANISMS.SCRAM256,
      securityProtocol: SECURITY_PROTOCOLS.SASL_SSL
    };
  }

  sasl_ssl_sha_512() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: SASL_MECHANISMS.SCRAM512,
      securityProtocol: SECURITY_PROTOCOLS.SASL_SSL
    };
  }

  ssl() {
    return {
      SSL: true,
      securityProtocol: 'SSL'
    };
  }

  ssl_mutualtls() {
    return {
      MUTUAL_TLS: true,
      securityProtocol: 'SSL'
    };
  }

  plaintext() {
    return {
      securityProtocol: SECURITY_PROTOCOLS.PLAINTEXT
    };
  }
}
